import { NavLink } from 'react-router-dom';
import { useCurrentUser } from '../../features/auth/api';
import { AuditLogModal } from '../../components/audit/AuditLogModal';
import { useState } from 'react';

export default function OrganizationTabs() {
  const { data: user } = useCurrentUser();

  const canManage = user?.type === 'ORG_OWNER' || user?.type === 'ORG_ADMIN';

  const [auditOpen, setAuditOpen] = useState(false);

  return (
    <>
      <div className="ta-right">
        <button className="btn btn--primary" onClick={() => setAuditOpen(true)}>
          Audit log
        </button>
      </div>

      <nav className="settings-tabs" role="tablist" aria-label="Organization Tabs">
        <NavLink
          to="/organization/overview"
          className={({ isActive }) => `settings-tabs__item ${isActive ? 'is-active' : ''}`}
        >
          Overview
        </NavLink>

        <NavLink
          to="/organization/warehouses"
          className={({ isActive }) => `settings-tabs__item ${isActive ? 'is-active' : ''}`}
        >
          Warehouses
        </NavLink>

        <NavLink
          to="/organization/loads/templates"
          className={({ isActive }) => `settings-tabs__item ${isActive ? 'is-active' : ''}`}
        >
          Templates
        </NavLink>

        {canManage && (
          <NavLink
            to="/organization/tiers"
            className={({ isActive }) => `settings-tabs__item ${isActive ? 'is-active' : ''}`}
          >
            Customer Tiers
          </NavLink>
        )}

        {canManage && (
          <NavLink
            to="/organization/users"
            className={({ isActive }) => `settings-tabs__item ${isActive ? 'is-active' : ''}`}
          >
            Users
          </NavLink>
        )}
      </nav>

      <AuditLogModal
        open={auditOpen}
        onClose={() => setAuditOpen(false)}
        entityType="ORGANIZATION"
      />
    </>
  );
}
